import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { USER_REPOSITORY } from '../../core/domain';
import { USER_API } from '../data-sources';
export var UserWebRepository = /*#__PURE__*/function () {
  function UserWebRepository(userApi) {
    _classCallCheck(this, UserWebRepository);

    this.userApi = userApi;
  }

  _createClass(UserWebRepository, [{
    key: "searchUser",
    value: function () {
      var _searchUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var responseOrError, userSummaries;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.userApi.searchUser(input);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                userSummaries = responseOrError.getValue();
                return _context.abrupt("return", Result.ok(userSummaries));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function searchUser(_x) {
        return _searchUser.apply(this, arguments);
      }

      return searchUser;
    }()
  }, {
    key: "getUsers",
    value: function () {
      var _getUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(useCaseInput) {
        var responseOrError, userSummaries;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.userApi.getUsers(useCaseInput);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                userSummaries = responseOrError.getValue();
                return _context2.abrupt("return", Result.ok(userSummaries));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUsers(_x2) {
        return _getUsers.apply(this, arguments);
      }

      return getUsers;
    }()
  }, {
    key: "changePassword",
    value: function () {
      var _changePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(useCaseInput) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.userApi.changePassword(useCaseInput);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue(); // Clear access token from local storage

                localStorage.clear();
                return _context3.abrupt("return", Result.ok(successMessage));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function changePassword(_x3) {
        return _changePassword.apply(this, arguments);
      }

      return changePassword;
    }()
  }, {
    key: "getUserById",
    value: function () {
      var _getUserById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var responseOrError, userResponse;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.userApi.getUserById(id);

              case 2:
                responseOrError = _context4.sent;

                if (!responseOrError.isFailure) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", mappingResultError(responseOrError));

              case 5:
                userResponse = responseOrError.getValue();
                return _context4.abrupt("return", Result.ok(userResponse));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getUserById(_x4) {
        return _getUserById.apply(this, arguments);
      }

      return getUserById;
    }()
  }, {
    key: "updateProfile",
    value: function () {
      var _updateProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(useCaseInput) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.userApi.updateProfile(useCaseInput);

              case 2:
                responseOrError = _context5.sent;

                if (!responseOrError.isFailure) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context5.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateProfile(_x5) {
        return _updateProfile.apply(this, arguments);
      }

      return updateProfile;
    }()
  }, {
    key: "getCurrentResponderLanguage",
    value: function getCurrentResponderLanguage() {
      return localStorage.getItem('responder_locale') || 'en';
    }
  }, {
    key: "changeResponderLanguage",
    value: function changeResponderLanguage(language) {
      localStorage.setItem('responder_locale', language);
    }
  }, {
    key: "getCurrentTestMakerLanguage",
    value: function getCurrentTestMakerLanguage() {
      return localStorage.getItem('test_maker_locale') || 'en';
    }
  }, {
    key: "changeTestMakerLanguage",
    value: function changeTestMakerLanguage(language) {
      localStorage.setItem('test_maker_locale', language);
    }
  }]);

  return UserWebRepository;
}();
export var userWebRepositoryProvider = {
  provide: USER_REPOSITORY,
  useFactory: function useFactory(userApi) {
    return new UserWebRepository(userApi);
  },
  inject: [USER_API]
};